import React, { memo, PureComponent } from 'react';
import { bool, any, shape, string } from 'prop-types';
import { connect } from 'react-redux';
import { UTCard, UTLabel, UTLoading } from '@widergy/energy-ui';
import { isEmpty } from '@widergy/web-utils/lib/array';
import { formValueSelector } from 'redux-form';
import { getInitialValues } from '@widergy/utilitygo-forms-web';

import { actionCreators as UserFormAction, formPropType } from 'redux/userFormHandlers';
import { PROCEDURE } from 'constants/userForms';
import { ENTITIES_COMPLAINT } from 'constants/reduxForms';

import ComplaintForm from './layout';
import styles from './styles.module.scss';

class ComplaintFormContainer extends PureComponent {
  handleSubmit = values => {
    this.props.dispatch(
      UserFormAction.submitPublicForm(
        values,
        this.props.complaintForm.fields,
        PROCEDURE,
        null,
        this.props.complaintForm,
        {
          onSuccess: this.handleResetForm,
          onFailure: this.handleResetForm,
          additionalValues: this.props.session,
          avoidNavigation: true,
          complaint: true
        }
      )
    );
  };

  render() {
    const { complaintForm, loading, fieldValues } = this.props;
    const initialValues = complaintForm ? getInitialValues(complaintForm.fields) : {};
    return (
      <UTCard className={styles.container}>
        {complaintForm && (
          <UTLabel className={styles.title} large>
            {complaintForm.name}
          </UTLabel>
        )}
        <UTLoading loading={loading || !complaintForm}>
          <ComplaintForm
            fieldValues={fieldValues}
            initialValues={initialValues}
            complaintForm={complaintForm}
            onSubmit={this.handleSubmit}
          />
        </UTLoading>
      </UTCard>
    );
  }
}

ComplaintFormContainer.propTypes = {
  loading: bool,
  complaintForm: formPropType,
  session: shape({ username: string }),
  fieldValues: any.isRequired // eslint-disable-line react/forbid-prop-types
};

const formSelector = formValueSelector(ENTITIES_COMPLAINT);

const mapStateToProps = store => ({
  loading: store.utility.complaintFormLoading || store.userForm.submitFormLoading,
  complaintForm: store.utility.complaintForm,
  fieldValues:
    store.utility.complaintForm && !isEmpty(store.utility.complaintForm.fields)
      ? formSelector(store, ...store.utility.complaintForm.fields.map(field => `id${field.id}`))
      : {}
});

export default connect(mapStateToProps)(memo(ComplaintFormContainer));
